import { render, staticRenderFns } from "./Gad7.vue?vue&type=template&id=2c6e3820&scoped=true&"
import script from "./Gad7.vue?vue&type=script&lang=ts&"
export * from "./Gad7.vue?vue&type=script&lang=ts&"
import style0 from "./Gad7.vue?vue&type=style&index=0&id=2c6e3820&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6e3820",
  null
  
)

export default component.exports